import { ChevronUp } from 'lucide-react';
import { useState, useEffect } from 'react';

const ScrollToTop = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!showScrollTop) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-16 right-8 p-4 bg-gradient-to-r from-[#172C5E] to-[#8339EA] text-white rounded-full shadow-lg hover:shadow-2xl transform hover:scale-110 transition-all duration-300 z-50 animate-none"
    >
      <ChevronUp className="w-6 h-6" />
    </button>
  );
};

export default ScrollToTop; 